import React, { useEffect, useRef, useState } from 'react';

import { useMedia } from 'react-use';
import { showToast } from '../shared/Toast';
import { CurrentUser } from '../calendar/Calendar';
import Button from '../shared/Button';
import {
  KitDocumentModel,
  MediaKitModel,
  SbMediaRequestModel,
  SbProfilesMediaModel,
  SubmissionKitDocumentModel,
} from '../submission_kits/components/KitModels';
import mediaKitService from '../services/MediaKitService';
import SubmissionKitMediaList from '../submission_kits/SubmissionKitMediaList';
import MediaKitDocumentList from '../media_kits/MediaKitDocumentList';
import sbProfilesMediaService from '../services/SbProfilesMediaService';
import { ProjectModel, SbCurrentUser } from './component/SbModel';
export interface SbMediaRequestProps {
  currentUser: SbCurrentUser;
  project: ProjectModel;
  submission_board: any;
  submissionKitTags: any;
  invalid_sb: boolean;
}
export default function SbMediaRequestPage({
  currentUser,
  project,
  submission_board,
  submissionKitTags,
  invalid_sb
}: SbMediaRequestProps) {
  // const [records, setRecords] = useState<SubmissionKitModel[]>([]);
  const [mediaKit, setMediaKit] = useState<MediaKitModel>();
  const [mediaKitDocuments, setMediaKitDocuments] = useState<KitDocumentModel[]>([]);
  const [showMediaKit, setShowMediaKit] = useState<boolean>(false);

  const [submissionKitDocuments, setSubmissionKitDocuments] = useState<
    SubmissionKitDocumentModel[]
  >([]);
  const [sbProfilesMedias, setSbProfilesMedias] = useState<SbProfilesMediaModel[]>([]);
  const [sbMediaRequests, setSbMediaRequests] = useState<SbMediaRequestModel[]>([]);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const observerRef = useRef(null);
  const listRef = useRef(null);
  const [noMoreData, setNoMoreData] = useState<string>('');
  const perPage: number = 12; // Number of records to fetch per page

  const is400_639Screen = useMedia('(min-width: 400px) and (max-width: 639px)', false);

  // Load first page
  useEffect(() => {
    console.log('sb::winodws initial');
    if (!invalid_sb) {
      fetchSbProfilesMedia();
    }
  }, []);
  // fetch media kit section start
  const loadMore = async (from: string) => {
    if (isLoading) {
      console.log('sb: loadMore isLoading is true from ' + from);
      return;
    }
    console.log('sb: set isLoading to true, isLoading was false from ' + from);
    setIsLoading(true);
  };
  useEffect(() => {
    if (isLoading) {
      console.log('sb::useEffect[isLoading] call fetchSubmissionBoards page: ' + page);
      const load = async () => {
        await fetchMediaKits(page);
      };
      load();
    }
  }, [isLoading]);

  useEffect(() => {
    if (showMediaKit) {
      loadMore('[]');
    }
  }, [showMediaKit]);

  useEffect(() => {
    const checkIfMoreNeeded = async () => {
      if (!invalid_sb) {
        const listBottom = listRef.current?.getBoundingClientRect().bottom || 0;
        // console.log('sb::winodws listBottom', listBottom, window.innerHeight);
        if (listBottom < window.innerHeight) {
          console.log('sb::winodw height more: call loadmore');
          await loadMore('checkIfMoreNeeded');
        }
      }
    };

    checkIfMoreNeeded();
    window.addEventListener('resize', checkIfMoreNeeded);

    return () => window.removeEventListener('resize', checkIfMoreNeeded);
  }, [mediaKitDocuments]);

  // Infinite scroll on reaching bottom
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        console.log('sb::last element visible');
        loadMore('[lastelementvisible]');
      }
    });

    if (observerRef.current) {
      observer.observe(observerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // fetch media kit section end
  const fetchSbProfilesMedia = async () => {
    try {
      if (invalid_sb) {
        return;
      }
      const resp = await sbProfilesMediaService.getBySubmissionBoard(
        project.uuid,
        submission_board.id
      );
      if (resp) {
        let sb_profiles_medias = [];
        if ('sb_profiles_medias' in resp) {
          sb_profiles_medias = resp.sb_profiles_medias;
          setSbProfilesMedias(resp.sb_profiles_medias);
        }

        if ('submission_kit_documents' in resp) {
          for (let index = 0; index < resp.sb_profiles_medias.length; index++) {
            const element = resp.sb_profiles_medias[index];
            const sbIndexTag = resp.submission_kit_documents.findIndex(
              (item) => item.tag == element.tag
            );
            if (sbIndexTag > 0) {
              resp.submission_kit_documents.splice(sbIndexTag, 1);
            }            
            if (element.media_status == 'Remove') {
              const sbIndex = resp.submission_kit_documents.findIndex(
                (item) => item.kit_document.id == element.kit_document_id
              );
              if (sbIndex !== -1) {
                resp.submission_kit_documents.splice(sbIndex, 1);
              }
            }
          }
          setSubmissionKitDocuments(resp.submission_kit_documents);
        }
        if ('sb_media_requests' in resp) {
          setSbMediaRequests(resp.sb_media_requests);
        }
      }
    } catch (error) {
      showToast('Error while fetching submission kits.', 'danger');
    } finally {
      console.log('sb: fetchMediaKits Out');
      console.log('sb: isLoading false');
      setIsLoading(false);
    }
  };

  const fetchMediaKits = async (pageParam: number) => {
    try {
      if (invalid_sb) {
        return;
      }

      if (noMoreData.length > 0 && pageParam != 0) {
        console.log('fetchSubmissionBoards no more data is set');
        return;
      }
      console.log('sb: fetchMediaKits In');
      if (mediaKitDocuments.length <= 0) {
        pageParam = 1;
      }
      let filter = '';
      const responseData = await mediaKitService.fetchMediaKits(filter, 'new', pageParam, perPage);
      if (responseData) {
        if (responseData.media_kit) {
          setMediaKit(responseData.media_kit);
        }
        if (responseData.kit_documents.length > 0) {
          if (responseData.kit_documents.length == perPage) {
            console.log('sb: fetchMediaKits page:', page);
            setPage((prev) => prev + 1);
            setNoMoreData('');
          } else {
            setNoMoreData('No more media...');
          }
          setMediaKitDocuments((prevRecords) => [...prevRecords, ...responseData.kit_documents]);
        } else {
          setNoMoreData('No more media...');
        }
        return;
      }
      if (mediaKitDocuments && mediaKitDocuments.length <= 0 && pageParam == 1) {
        setNoMoreData('No more media...');
      }
    } catch (error) {
      showToast('Error while fetching submission kits.', 'danger');
    } finally {
      console.log('sb: fetchMediaKits Out');
      console.log('sb: isLoading false');
      setIsLoading(false);
    }
  };

  const addToSubmissionKit = async (kit_document: any, tag: string) => {
    if (invalid_sb) {
      return;
    }

    let _sp_profiles_media = [...sbProfilesMedias];
    // if image is already added in SK or PM then ignore it. dont allow same image
    const elementPresentSk = submissionKitDocuments.findIndex(
      (item) => item.kit_document.id == kit_document.id
    );
    if (elementPresentSk >= 0) {
      showToast('Image/video is already added.', 'danger');
      // if not removed from PM then return false
      const elementPresent2 = _sp_profiles_media.findIndex(
        (item) => item.kit_document_id == kit_document.id && item.media_status == 'Removed'
      );
      if (elementPresent2 < 0) {
        return false;
      }
    }
    const elementPresent = _sp_profiles_media.findIndex(
      (item) => item.kit_document_id == kit_document.id && item.media_status == 'Add'
    );
    if (elementPresent >= 0) {
      showToast('Image/video is already added.', 'danger');
      return false;
    }
    const resp = await sbProfilesMediaService.create(
      project.uuid,
      submission_board.id,
      kit_document.id,
      0,
      tag
    );
    if (resp && 'sp_profiles_media' in resp) {
      await fetchSbProfilesMedia();
    }
    return true;
  };

  const removeFromSbProfilesMedia = async (
    sbProfilesMediaModel: SbProfilesMediaModel
  ): Promise<boolean> => {
    if (invalid_sb) {
      return;
    }

    console.log('removeFromSbProfilesMedia', sbProfilesMediaModel);
    console.log('submissionKitDocuments', submissionKitDocuments);
    console.log('sbProfilesMedias', sbProfilesMedias);
    try {
      // remove only for a given submission board
      const resp = await sbProfilesMediaService.delete(project.uuid, sbProfilesMediaModel);
      if (resp) {
        await fetchSbProfilesMedia();
        return true;
      }
    } catch (error) {}
    return false;
  };
  const removeFromSubmissionKit = async (
    submissionKitDocument: SubmissionKitDocumentModel
  ): Promise<boolean> => {
    if (invalid_sb) {
      return;
    }

    console.log('removeFromSubmissionKit', submissionKitDocument);
    console.log('submissionKitDocuments', submissionKitDocuments);
    console.log('sbProfilesMedias', sbProfilesMedias);
    const resp = await sbProfilesMediaService.create(
      project.uuid,
      submission_board.id,
      submissionKitDocument.kit_document.id,
      1,
      submissionKitDocument.tag
    );
    if (resp && 'sp_profiles_media' in resp) {
      await fetchSbProfilesMedia();
      return true;
    }
    return true;
  };
  const refreshClicked = async () => {
    setNoMoreData('');
    setPage(1);
    setMediaKitDocuments([]);
  };

  return (
    <div className="w-full flex flex-1 mx-auto bg-gray-50">
      {invalid_sb && (
        <div className="flex flex-col items-center justify-center w-full h-screen gap-4">
          <div className="text-base font-normal">
            While we went in a different direction this time, your submission was solid and we
            appreciate you being part of the process.
          </div>
          <div className="text-base font-normal">
            Keep your FILMIK profile fresh — we'll reach out again as soon as another spot opens up
            on the project.
          </div>
        </div>
      )}

      {!invalid_sb && (
        <div className="w-full px-4 py-4 mx-auto">
          <div className="flex flex-col relative w-full relative">
            <div className="flex items-center justify-between">
              <span className="text-2xl md:text-3xl font-light text-gray-900">{project.title}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-2xl md:text-3xl font-semibold text-gray-900">
                {submission_board.title}
              </span>
            </div>

            {sbMediaRequests && sbMediaRequests.length > 0 && (
              <div className="flex flex-col items-start py-1 ">
                <div className="text-xs font-extralight">Notes:</div>
                {sbMediaRequests.map((item, index) => {
                  return (
                    <div key={index} className="flex items-center justify-between">
                      {item.notes}
                    </div>
                  );
                })}
              </div>
            )}

            {/* top filter bar */}
            <div
              style={{
                position: 'sticky',
                top: '0px',
                zIndex: 2,
                backgroundColor: 'white',
              }}
            >
              <div className="scrollable-content border overflow-y-autojustify-items-center px-2 py-1">
                <span
                  className={
                    'font-semibold text-gray-900 ' +
                    (showMediaKit ? 'text-base' : 'text-3xl leading-9')
                  }
                >
                  Submission Kit{' '}
                  {showMediaKit && (
                    <span className="px-1 text-xs font-normal">
                      (Drag and Drop from All media into following categories.)
                    </span>
                  )}
                </span>
                <div className="flex w-full flex-col items-end">
                  <div className={(is400_639Screen ? 'px-0' : 'p-0') + ' w-full'}>
                    <SubmissionKitMediaList
                      from="media_request"
                      submissionKitDocuments={submissionKitDocuments}
                      sbProfilesMedias={sbProfilesMedias}
                      addToSubmissionKit={async function (
                        kit_document: any,
                        tag: string
                      ): Promise<boolean> {
                        return await addToSubmissionKit(kit_document, tag);
                      }}
                      removeFromSubmissionKit={async function (
                        submissionKitDocument: SubmissionKitDocumentModel
                      ): Promise<boolean> {
                        return await removeFromSubmissionKit(submissionKitDocument);
                      }}
                      removeFromSbProfilesMedia={async function (
                        sbProfilesMediaModel: SbProfilesMediaModel
                      ): Promise<boolean> {
                        return await removeFromSbProfilesMedia(sbProfilesMediaModel);
                      }}
                      submissionKitTags={submissionKitTags}
                    ></SubmissionKitMediaList>
                  </div>
                  <div className="px-2 py-1 items-end">
                    {!showMediaKit && (
                      <div
                        onClick={() => {
                          setShowMediaKit(true);
                        }}
                        className="text-base leading-6 font-medium items-center mr-2 text-blue-500 cursor-pointer"
                      >
                        Add Media
                      </div>
                    )}
                    {showMediaKit && (
                      <div
                        onClick={() => {
                          setShowMediaKit(false);
                        }}
                        className="text-base leading-6 font-medium items-center mr-2 text-blue-500 cursor-pointer"
                      >
                        Close Media
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* top filter bar */}
            {showMediaKit && (
              <div>
                <div className="scrollable-content border overflow-y-auto mt-1 justify-items-center p-2">
                  <span className="text-3xl leading-9 font-semibold text-gray-900">All media</span>
                  <div className="flex w-full flex-col">
                    <div ref={listRef} className={(is400_639Screen ? 'px-0' : 'p-0') + ' w-full '}>
                      <MediaKitDocumentList
                        from="submission_kit"
                        mediaKitModel={mediaKit}
                        kit_documents={mediaKitDocuments}
                        refreshMedias={function (): void {
                          refreshClicked();
                        }}
                        
                        removeMediaHandler={async function (kit_document: any): Promise<boolean> {
                          return true;
                        }}
                        mediaSetting={{
                          imageCount: 0,
                          videoCount: 0,
                          imageAllowed: 0,
                          videoAllowed: 0,
                        }}
                      ></MediaKitDocumentList>
                    </div>
                  </div>
                  <div ref={observerRef} className="w-full py-2 flex justify-center border">
                    {isLoading && (
                      <div className="justify-items-center flex">
                        <div className="w-full font-bold text-xl">Loading more...</div>
                      </div>
                    )}
                    {/* {noMoreData.length > 0 && (
                  <div className="justify-items-center flex">
                    <div className="w-full font-bold text-xl">No more submission kits...</div>
                  </div>
                )} */}
                    {!isLoading && noMoreData.length <= 0 && (
                      <div className="justify-items-center flex">
                        <Button
                          className="flex cursor-pointer max-w-xs"
                          onClick={() => {
                            // setIsLoading(true);
                            // setPage((prevPage) => prevPage + 1);
                            // setReachedBottom(true);
                          }}
                        >
                          Load more...
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
